import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderToastService, Pageable, ElderTableComponent } from '@elderbyte/ngx-starter'
import { Router } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { PropertyConf } from '../property-conf'
import { FilterBuilder } from '../../../orders/filter-builder'
import { PropertyService } from '../../property.service'
import { Property } from '../../property'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { PropertyInputComponent } from '../../property-input/property-input.component'
import { MatIcon } from '@angular/material/icon'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort } from '@angular/material/sort'

@Component({
  selector: 'app-property-conf-table',
  templateUrl: './property-conf-table.component.html',
  styleUrls: ['./property-conf-table.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    PropertyInputComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class PropertyConfTableComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _properties$ = new BehaviorSubject<PropertyConf[]>([])

  @Input()
  public name: string

  private propertyService = inject(PropertyService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get properties$(): Observable<PropertyConf[]> {
    return this._properties$.asObservable()
  }

  @Input()
  public set properties(properties: PropertyConf[]) {
    if (properties) {
      this.propertyService
        .findAllPaged(new Pageable(0, 100), [
          FilterBuilder.ids(properties.map((propertyConf) => propertyConf.propertyId)),
        ])
        .subscribe({
          next: (props) => {
            this.populate(properties, props.content)
            this._properties$.next(properties)
          },
          error: (err) => this.toastService.error('Failed to load property specs!', err),
        })
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private populate(configs: PropertyConf[], properties: Property[]): void {
    for (const config of configs) {
      const property = properties.find((prop) => prop.id === config.propertyId)

      if (property) {
        config.property = property
      } else {
        this.log.warn('Failed to populate. Could not find Property with id ' + config.propertyId)
      }
    }
  }
}
